import { IParsedQsParams } from '../../types/qsParams/expectedQsParams';

interface IParams {
  isWebview: boolean;
  platform: string | null;
  defaultSource: string;
  queryParams: IParsedQsParams;
}

/**
 * Возвращает наиболее приоритетный источник
 * */
const selectSourceByPriority = (queryParams: IParsedQsParams): string | undefined =>
  queryParams.utm_source || queryParams.cian_source;

/* NOTE: utm_source используется для интеграции с внешними сервисами, cian_source - с внутренними */
/**
 * Возвращает поле source для создания заявки
 * */
export const getMessageSource = ({ isWebview, platform, defaultSource, queryParams }: IParams): string => {
  const { referrer } = document;

  const sourceByPriority = selectSourceByPriority(queryParams);

  const source = sourceByPriority ? `${defaultSource}_${sourceByPriority}` : defaultSource;

  switch (true) {
    case isWebview:
      return platform ? `${source}_${platform}` : source;

    case referrer.includes('podbor-rieltora'):
      return `${defaultSource}-landing-page`;

    default:
      return source;
  }
};
